<div class="col-lg-12">
    <div class="card">
        <div class="card-body">
            <img src="../../../../assets/images/logo-bsf.png" alt="BSF LOGO"> 
             <div style="float:right;">
                {{time}} 
            </div> 
            <div class="row">
                <div class="col-12">
                    
                    <div style="float:left;">
                        <i class="far fa-newspaper"></i> แบบเสนอสินเชื่อออนไลน์ ปี 2565/2566
                    </div> 
                    <div style="float:right;">
                        Supcode : {{supcode}} <u> {{supname}} </u>
                    </div> 
                </div>
                
            </div>
            <div class="row">
                <div class="col-12">
                    <div style="background-color: rgb(255, 255, 179);">
                         <p *ngFor="let item of datafamer"> <i class="far fa-user"></i> โควตา : {{item.fmcode_b1}} : {{item.fmname}} ที่อยู่ {{item.address}} โทร {{item.TEL}}</p>
                    </div>
                </div>
                
            </div>
            <div class="row">
                <div class="col-12">
                    <table class="table table-sm">
                        <thead>
                            <tr class="table-success">
                                <td>เลขที่คำขอ </td>
                                <td>วันเวลา</td>
                                <td>หมายเลขแปลง</td>
                                <td>ข้อมูลแปลง</td>
                                <td>เหตุผลการขอ</td>
                                <td>จำนวนเงิน</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of dataone; index as i">
                                <td>{{item.docid}}</td>
                                <td>{{item.datepost_th}}</td>
                                <td>{{item.intlandno}}</td>
                                <td> อ้อย {{item.canename}} พท. {{item.landvalue}} ไร่ เป้าผลผลิต {{item.target_yield}} </td>
                                <td>{{item.comment1}}</td>
                                <td>{{item.money_amt.toLocaleString()}}</td>
                            </tr>
                            <tr class="table-success">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>*** รวม ***</td>
                                <td> <U>{{summoney}}</U> </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
            </div>

            <!-- ผลผลิต -->
            <div class="row">
                <table class="table table-sm">
                    <tbody class="text-bold" *ngFor="let item of retadata">
                        <tr>
                            <td>ผลผลิตปี 60/61</td>
                            <td> {{item.yield6061.toLocaleString()}} </td>
                            <td>วงเงินปุ๋ยอนุมัติ</td>
                            <td><u>{{item.manure_amount.toLocaleString()}}</u></td>
                            <td>วงเงินส่งเสริมอนุมัติ</td>
                            <td> <u>{{item.credit_amount.toLocaleString()}}</u>  </td>
                            <td> วงเงินส่งเสริมยังไม่อนุมัติ  (P) </td>
                            <td> <u> {{item.credit_amountP.toLocaleString()}}</u>  </td>
                        </tr>
                        <tr>
                            <td>ผลผลิตปี 61/62</td>
                            <td>{{item.yield6162.toLocaleString()}}</td>
                            <td>วงเงินปุ๋ยใช้ไป</td>
                            <td><u>{{item.puy6566.toLocaleString()}}</u></td>
                            <td>วงเงินส่งเสริมที่ใช้ไป</td>
                            <td> <u>{{item.btMoney6364.toLocaleString()}}</u>  </td>
                            
                        </tr>
                        <tr>
                            <td>ผลผลิตปี 62/63</td>
                            <td>{{item.yield6263.toLocaleString()}}</td>
                            <td>วงเงินปุ๋ยคงเหลือ</td>
                            <td><u>{{item.manure_left.toLocaleString()}}</u></td>
                            <td>วงเงินส่งเสริมที่คงเหลือ</td>
                            <td> <u>{{item.credit_left.toLocaleString()}}</u>  </td>
                           
                        </tr>
                        <tr>
                            <td>ผลผลิตปี 63/64</td>
                            <td>{{item.yield6364.toLocaleString()}}</td>
                           <td>ประเมินอ้อย</td>
                           <td> <u>{{item.sumassess.toLocaleString()}}</u>  </td>
                            
                        </tr>
                        <tr>
                            <td>ผลผลิตปี 64/65</td>
                            <td>{{item.yield6465.toLocaleString()}}</td>
                          
                        </tr>

                        <tr>
                            <td>ผลผลิตปี 65/66</td>
                            <td>.........................</td>
                        </tr>
                       
                    </tbody>

                   
                </table>
            </div>
            <!-- ผลผลิต -->
            <!-- เงินประเมิน -->

            <div class="row"  *ngFor="let item of retadata">
                <p>
                    บาทต่อตัน (ประเมิน 65/66) ปุ๋ย,ยา <u>{{item.btFactor.toLocaleString()}}</u>  เงินส่งเสริมที่ใช่ไป <u> {{item.btMoney.toLocaleString()}}</u> รวมขอครั้งนี้ .................. รวม ...............
                </p>
               
                <p>
                    ระยะยาว (ยอดหนี้ ..................).................... รวมทั้งสิ้น ...................
                </p>
                <p>
                    บาทต่อตัน (ผลผลิต 63/64) ปุ๋ย,ยา <u>{{item.btFactor6364.toLocaleString()}}</u>  เงินส่งเสริมที่ใช่ไป <u>{{item.btMoney6364.toLocaleString()}}</u>  รวมขอครั้งนี้ .................. รวม ...............
                </p>
                <p>
                    ระยะยาว (ยอดหนี้ ..................).................... รวมทั้งสิ้น ...................
                </p>
               
            </div>
           
            <!-- เงินประเมิน -->

            <!-- ขอเบิก -->
            <div class="row">
                <table class="table table-sm">
                    <tbody>
                        <tr>
                            <td>ขอเบิกเงินส่งเสริม สำหรับปีการผลิตอ้อย 65/66</td>
                            <td>.........................  บาท วงเงิน (  ) ปกติ  (  ) เกินวงเงิน</td>
                        </tr>
                        <tr>
                            <td>ขอเบิกเงินส่งเสริม สินเชื่อระยะยาว</td>
                            <td>.........................  บาท ผ่อนชำระ</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td> (  )  2 ปี  (  ) 3 ปี (  ) 4 ปี  (  ) 5 ปี (  ) 6 ปี</td>
                        </tr>
                        <tr>
                            <td>ขอเบิกเงินส่งเสริมค่าซ่อมรถ ชำระปี 65/66</td>
                            <td>.........................  บาท วงเงิน (  ) ปกติ  (  ) เกินวงเงิน</td>
                        </tr>
                        <tr>
                            <td>ขอเบิกเงินส่งเสริมค่าตัด ชำระปี 65/66</td>
                            <td>.........................  บาท วงเงิน (  ) ปกติ  (  ) เกินวงเงิน</td>
                        </tr>
                        <tr>
                            <td colspan="2" class="text-bold">( &nbsp; &nbsp; &nbsp; &nbsp;) &nbsp;ชาวไร่ปรับโครงสร้างหนี้  
                                &nbsp;( &nbsp; &nbsp; &nbsp; &nbsp;) &nbsp;หมดหนี้  &nbsp;( &nbsp; &nbsp; &nbsp; &nbsp;) &nbsp;ไม่หมดหนี้</td>
                        </tr>
                    </tbody>
                </table>
            </div>
              <!-- ขอเบิก -->

            <!-- More Comemnt -->
            <div class="row">
                <table class="table table-sm">
               
                    <tbody>
                        <tr>
                            <td colspan="4">  ความคิดเห็นเพิ่มเติม.......................................
                            ........................................................................
                            ........................................................................
                            ..................................
                            </td>
                        </tr>
                        <tr>
                            <td>
                            ........................................................................
                            ........................................................................
                            ........................................................................
                            ..................................
                            </td>
                        </tr>
                        <tr>
                            <td>
                            ........................................................................
                            ........................................................................
                            ........................................................................
                            ..................................
                            </td>
                        </tr>
                       
                    </tbody>
                </table>
            </div>
           <!-- More Comemnt -->
            
           <!-- Lisence -->
           <div class="row">
            <table class="table table-sm">
                <tbody>
                    <tr>
                        <td></td>
                        <td> ลงชื่อ.....................................ชาวไร่ผู้กู้ </td>
                        <td></td>
                        <td> ลงชื่อ.....................................นักส่งเสริม</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>  ............./.........../..............</td>
                        <td></td>
                        <td> ............./.........../..............</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td> ลงชื่อ.....................................ผู้จัดการโซน </td>
                        <td></td>
                        <td> ลงชื่อ.....................................หัวหน้าส่วน</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>  ............./.........../..............</td>
                        <td></td>
                        <td> ............./.........../..............</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td> ลงชื่อ.....................................ผู้อำนวยการ </td>
                        <td></td>
                        <td> ลงชื่อ.....................................กรรมการจัดการ</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>  ............./.........../..............</td>
                        <td></td>
                        <td> ............./.........../..............</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
           </div>
             <!-- Lisence -->
         

           
        </div>
    </div>
</div>